import { PiWarningCircleFill } from "react-icons/pi";
import { colors } from "../styles/theme.js";

const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: colors.text,
  },
};

export const WarningComponent = ({ header, message }) => {
  return (
    <div style={styles.loadingContainer}>
      <PiWarningCircleFill size={100} color={colors.primary} />
      <div style={{ fontSize: 24, paddingBottom: 10 }}>{header}</div>
      <div style={{ fontSize: 16 }}>{message}</div>
    </div>
  );
};
